import api from "./api";

export const getVehicleOpportunities = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      vehicle_uuid: params.vehicle_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: params.order_by || ["created_at"],
      order_direction: params.order_direction || ["DESC"],
    };

    if (params.search) {
      body.search = params.search;
    }

    const response = await api.post("/v1/tenant/alert/vehicle/list", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle opportunities:", error);
    throw error;
  }
};

